import { CompanyData } from 'src/app/domains/common.domain';
import { Company } from 'src/app/model/company';

export function prepareCompanyData(companyData: Company | CompanyData): Company | CompanyData {
  if (companyData.headoffice === 'true') {
    companyData.headsubsidiary = 'hauptbetrieb';
  }
  if (companyData.subsidiary === 'true') {
    companyData.headsubsidiary = 'nebenbetrieb';
  }
  if (companyData.main_businesses_part_time === 'true') {
    companyData.headsubsidiary = 'main_businesses_part_time';
  }
  if (companyData.in_auxiliary_operation === 'true') {
    companyData.headsubsidiary = 'in_auxiliary_operation';
  }

  return companyData;
}
